{
    "SchedulereportLabel": "Planen Sie diesen Bericht:",
    "SchedulereportNotscheduledOptionLabel": "[Nicht geplant]",
    "SchedulereportOnceOptionLabel": "Einmal",
    "SchedulereportHourlyOptionLabel": "Stündlich",
    "SchedulereportDailyOptionLabel": "Täglich",
    "SchedulereportWeeklyOptionLabel": "Wöchentlich",
    "SchedulereportMonthlyOptionLabel": "Monatlich",
    "SchedulereportResetButtonLabel": "Zurücksetzen",
    "SchedulereportPromptReset": "Möchten Sie den Zeitplan wirklich zurücksetzen?",
    "SchedulereportPromptButtonConfirmLabel": "Bestätigen",
    "SchedulereportPromptButtonCancelLabel": "Absagen",
    "ReportScheduling_SectionHeader": "Berichtsplanung",
    "NAME": "ReportScheduling"
}